import { axiosWithRetry } from 'utils/axios';
import { MojoContextType } from 'utils/chatContext/types';
import { HTTP_REQUEST_METHODS } from 'constants/http';

export const getPopularTopics = async (mojoContext: MojoContextType) => {
  const { data } = await axiosWithRetry({
    body: { context: mojoContext },
    method: HTTP_REQUEST_METHODS.POST,
    url: `${process.env.REACT_APP_BASE_PROPEL_URL}/v1/conversation-vendor-commands/hand-raise?source=introduction`,
  });
  return data;
};
